module.exports = __webpack_public_path__ + "static/media/psql.ff8311da.png";